import { PostUserEventRequest, UserEventType } from '@finance-lab/utils/types'
import ApiBase from './Api'

const USER_EVENT_API_PATHS = {
    EVENTLOG: '/eventlog',
}

class UserEventApi extends ApiBase {
    async logEvent(eventType: UserEventType, eventDetails: Record<string, unknown> = {}) {
        const response = await this._postRequest<PostUserEventRequest>(USER_EVENT_API_PATHS.EVENTLOG, {
            eventType: eventType,
            ...eventDetails,
        })
        return response
    }
}

export default UserEventApi
